module.exports = __webpack_public_path__ + "static/media/ic_mask_stop.b5356393.svg";